
import {InjectionToken} from '@angular/core';

import {Subscription} from 'rxjs/internal/Subscription';
import {Params, Router} from "@angular/router";
import {BehaviorSubject} from "rxjs";
import { AbstractControl, ValidatorFn } from '@angular/forms';
import {TokenDetail} from "../modules/main-layer/main-layer.component";



export const CONTAINER_DATA = new InjectionToken<{}>('CONTAINER_DATA');


export class Util {
  static loading: BehaviorSubject<number> = new BehaviorSubject(0);

  static persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
  static englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

  static persianChar = ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح",
    "ج", "چ", "ش", "س", "ی", "ب", "ل", "ا", "ت", "ن",
    "م", "ک", "گ", "ظ", "ط", "ز", "ر", "ذ", "د", "پ",
    "و", "؟", "ئ"];
  static englishChar = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p",
    "[", "]", "a", "s", "d", "f", "g", "h", "j", "k",
    "l", ";", "'", "z", "x", "c", "v", "b", "n", "m",
    ",", "?", "m"];

  static isNull(s: any): boolean {
    return (s == null || s === '' || s === 'null' || s === undefined || s === 'undefined');
  }


   static convertFarsiToEnglish(text: string): string {
    const farsiNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    // Convert Farsi numerals to English
    farsiNumbers.forEach((farsiNum, index) => {
      text = text.replace(new RegExp(farsiNum, 'g'), englishNumbers[index]);
    });


    // Replace any other specific Farsi characters if necessary
    // Add other replacements if you need to convert specific Farsi letters to English

    return text;
  }


   static  decodeJwt(token: string): TokenDetail |null{
    try {
      const payload = token.split('.')[1];

      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );

      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Invalid JWT', e);
      return null;
    }
  }


  static seperateDateFromTime(dateString: string): string {
    const [date] = dateString.split('T');
    return date;
  }

  static separateTimeFromDate(dateString: string): string {
    const [, time] = dateString.split('T');
    return time ? time : '';
  }

  static separateTimeFromDateWithoutSecond(dateString: string): string {
    const [, time] = dateString.split('T');
    if (time) {
      const [hour, minute] = time.split(':');
      return `${hour}:${minute}`;
    }
    return '';
  }

  static getDayFromDate(dateString: string): number {
    const [datePart] = dateString.split('T');
    const day = datePart.split('-')[2];
    return day ? Number(day ):0;
  }

  static isValidUuid(value: string): boolean {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(value);
  }

  static isValidNumber(value: string): boolean {
    if (value === null || value.trim() === '') {
      return false; // Empty or null strings are not valid numbers
    }

    const parsedNumber = Number(value);
    return !isNaN(parsedNumber) && isFinite(parsedNumber);
  }

  static isValidPassportNumber(value: string): boolean {
    // Regex to validate the passport number
    const passportRegex = /^[a-zA-Z][0-9]{0,9}$/;

    // Check if the value matches the regex and length is between 8 and 11
    return passportRegex.test(value) && value.length >= 8 && value.length <= 11;
  }

  static isValidTime(value: string): boolean {
    // Regex to validate time in 24-hour format (hh:mm)
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

    // Test the value against the regex
    return timeRegex.test(value);
  }

  static getMessageIcon(typ: string): string {
    const type = ['', 'info', 'success', 'warning', 'danger'];

    let img = '';
    switch (typ) {
      case 'danger':
        img = 'error';
        break;
      case 'success':
        img = 'check_circle';
        break;
      case 'warning':
        img = 'warning';
        break;
      case 'info':
        img = 'info';
        break;
    }
    return img;
  }


  static unsubscribe(subscription?: Subscription) {
    if (subscription && subscription != null)
      subscription.unsubscribe();
  }

  static toEnglishNumber(value: string) {
    if (!value) {
      return value;
    }
    const ind = this.persianNumbers.findIndex((testValue) => {
      return testValue === value;
    });

    if (ind !== -1) {
      return this.englishNumbers[ind];
    }
    return value;
  }

  static toPersianNumber(value: string) {
    if (!value) {
      return value;
    }
    const ind = this.englishNumbers.findIndex((testValue) => {
      return testValue === value;
    });

    if (ind !== -1) {
      return this.persianNumbers[ind];
    }
    return value;
  }

  static convertArbicYToPersianY(value:string):string{
    return value.replace(/ي/g, 'ی');
  }

  static toEnglishChar(value: string, shift: boolean) {
    if (!value) {
      return value;
    }
    const ind = this.persianChar.findIndex((testValue) => {
      return testValue === value;
    });

    if (ind !== -1) {
      return shift ? this.englishChar[ind].toUpperCase() : this.englishChar[ind];
    }
    return value;
  }

  static toPersianChar(value: string) {
    if (!value) {
      return value;
    }
    const ind = this.englishChar.findIndex((testValue) => {
      return testValue === value;
    });

    if (ind !== -1) {
      return this.persianChar[ind];
    }
    return value;
  }

  static convertPersianNumber(value: string) {
    if (!value) {
      return value;
    }
    for (let i = 0; i < this.englishNumbers.length; i++) {
      value = value.replace(new RegExp(this.persianNumbers[i], "g"), this.englishNumbers[i]);
    }
    return value;
  }

  static routeToCurrentUrl(router: Router, url: string) {
    router.navigateByUrl('').then(() => {
      router.navigateByUrl(url);
    });
  }

  static lPad(x: number, y: number, z: string) {
    try {
      if (z == null || y === 0) {
        return "" + x;
      }
      let ret = "" + x;
      while (ret.length <= y - 1) {
        ret = z + ret;
      }
      return ret;
    } catch (ex) {
    }
    return null;
  }

  static convertMilisecToTime(milisec: number) {
    const time = Math.floor(milisec);
    let sec = Math.floor((time / 1000) % 60).toString();
    let min = Math.floor((time / (1000 * 60)) % 60).toString();
    let hour = Math.floor((time / (1000 * 60 * 60))).toString(); // if divide to 24 can add day too
    sec = sec.length === 1 ? '0' + sec : sec;
    min = min.length === 1 ? '0' + min : min;
    hour = hour.length === 1 ? '0' + hour : hour;
    return hour + ":" + min + ":" + sec;
  }

  static convertNumberToEnglish(value: string) {
    let retval = "";
    if (this.isNull(value)) {
      return value;
    }
    const temp = value.toString();
    for (let i = 0; i < temp.length; i++) {
      retval += this.toEnglishNumber(temp.charAt(i));
    }
    return retval;
  }

  static convertBeanToEnglish(bean: any): any {
    return JSON.parse(Util.convertNumberToEnglish(JSON.stringify(bean)));
  }



  static queryStringToJSON(queryString: string): Params {
    if (queryString.indexOf('?') > -1) {
      queryString = queryString.split('?')[1];
    }
    const pairs = queryString.split('&');
    const result: Params = {};
    pairs.forEach((pair: string) => {
      const temp = pair.split('=');
      result[temp[0]] = decodeURIComponent(temp[1] || '');
    });
    return result;
  }

  static getString(value: string | null | undefined): string {
    return value && value != null ? value : "";
  }

  static getNumber(value: number | null | undefined, emptyValue: number = 0): number {
    return value && value != null ? value : emptyValue;
  }

  static getBoolean(value: boolean | null | undefined, emptyValue: boolean = false): boolean {
    return value && value != null ? value : emptyValue;
  }



  static str2ab(str: string): ArrayBuffer {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
  }



  static stringToByteArray(binary_string: string) {
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }



  static extractSignMessage(temp: any): string {
    delete temp.messageBeans;
    delete temp.guid;
    delete temp.sign;
    delete temp.error;
    const keys = Object.keys(temp).sort((a,b)=>a.localeCompare(b));
    let retval = "";
    if (keys.length>0) {
      for (const key of keys) {
        if (!Util.isNull(temp[key])) {
          retval += Util.extractAttributeValues(temp[key]);
        }
      }
    }
    return retval;
  }

  static extractSignMessageArray(invoke: any[]): string {
    let retval = "";
    if (invoke!=null && invoke.length>0) {
      for (const o of invoke) {
        if (!Util.isNull(o))
          retval += Util.extractAttributeValues(o);
      }
    }
    return retval;
  }

  static extractAttributeValues(invoke: any): string {
    if (invoke.hasOwnProperty("messageBeans"))
      return Util.extractSignMessage(invoke);
    else if (Array.isArray(invoke))
      return Util.extractSignMessageArray(invoke as any[]);
    else
      return invoke.toString();
  }


  static isValidNationalCode(): ValidatorFn {
    return (control: AbstractControl): {[key: string]: boolean} | null => {
      let isBadFormat: boolean = false;
      let val: string = control.value;
      let value:string = val.toString();
      let nationalCode: string = Util.convertNumberToEnglish(value);
      if (value != null && value.trim() != '') {
        if (nationalCode === '-1') {
          isBadFormat = true;
        } else {
          if (nationalCode.length == 10) {
            const ld = Number(nationalCode.substring(9, 10));
            let n = 0, m;
            for (let i = 0; i < 9; i++) {
              n = n + Number(nationalCode.substring(i, i + 1)) * (10 - i);
            }
            m = n % 11;
            if ((m == 0 && ld == 0) || (m == 1 && ld == 1) || (m > 1 && ld == 11 - m)) {
              isBadFormat = false;
            } else {
              isBadFormat = true;
            }
          } else {
            isBadFormat = true;
          }
        }
      } else {
        isBadFormat = true;
      }
      return isBadFormat ? {noNationalCode: true} : null;
    }
  }

  static isValidPassportCode(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      let isBadFormat: boolean = false;
      let val: string = control.value;
      let value: string = val.toString();
      let passportCode: string = Util.convertNumberToEnglish(value);
      if (value != null && value.trim() != '') {
        if (passportCode === '-1') {
          isBadFormat = true;
        } else {
          if (passportCode.length == 9) {
            let splitArr: string[] = passportCode.split('');
            let find1: boolean = false;
            let find2: boolean = false;
            // @ts-ignore
            for (let i = 0; i <= Util.englishChar.length; i++) {
              if (splitArr[0] == Util.englishChar[i].toUpperCase()) {
                find1 = true;
                break;
              }
            }

            for (let i = 1; i < splitArr.length; i++) {
              //@ts-ignore
              for (let j = 0; j <= Util.englishChar.length; j++) {
                if (splitArr[i] == Util.englishChar[j].toUpperCase()) {
                  find2 = true;
                  break;
                }
              }
            }


            if (!find1 || find2) {
              isBadFormat = true;
            } else {
              isBadFormat = false;
            }

          } else {
            isBadFormat = true;
          }
        }
      }
      return isBadFormat ? {noNationalCode: true} : null;
    }
  }

  static changeArabicEToFarsiE(str:string):string{
    let returnVal:string = '';
    let splitStr:string[] = str.split('');
    for (let i = 0; i < splitStr.length; i++){
      if(splitStr[i] == 'ي'){
        splitStr[i] = 'ی';
      }
      returnVal = returnVal + splitStr[i];
    }
    return returnVal;
  }//end changeArabicEToFarsiE
  static convertPersianToEnglishDigits(value: string): string {
    const persianDigits = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    persianDigits.forEach((item, index) => {
      value = value.replace(item, englishDigits[index]);
    });

    return value;
  }


  static removeComma(val:string):string{
    let retVal:string = '';
    if(val.indexOf(',') > -1){
      let splitStr:string[] = val.split(',');
      splitStr.forEach(item => {
        retVal = retVal + item;
      })
    }
    else{
      retVal = val;
    }
    return retVal;
  }


  static ConvertNumericToLetters(inputVal:number, isToman:boolean):string{
    //isToman == true ==> تومان
    //isToman == false ==> ریال
    const units = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
    const tenUnits = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده' ]
    const tens = ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'هشتاد', 'نود'];
    const hundreds = ['', 'صد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];

    let retVal:string = '';
    let LArray:string[] = [];
    let rArray:number[] = [];
    let m:number = inputVal;
    if(isToman){
      m = Math.floor(inputVal/10);
    }
    while (m >= 10){
      rArray.push(m % 10);
      LArray.push('');
      m = Math.floor(m / 10);
      //console.log(m);
    }
    rArray.push(m);
    LArray.push('');
    for (let i=0; i < rArray.length; i++){
      if(i % 3 == 0){
        LArray[i] = units[rArray[i]];
      }
      if(i % 3 == 1){
        LArray[i] = tens[rArray[i]];
        if(LArray[i] == 'ده'){
          LArray[i] = '*';
          LArray[i-1] = tenUnits[rArray[i-1]];
        }
      }
      if(i % 3 == 2){
        LArray[i] = hundreds[rArray[i]];
      }
    }
    let arrayList:string[] = [];

    for(let i = 0; i < LArray.length; i++){
      if(i==3 && (LArray[3] || LArray[4] || LArray[5])){
        LArray[i] = LArray[i] + ' هزار';
        if(LArray[i].trim() == 'هزار'){
          LArray[i] = '';
          LArray[i+1] = LArray[i+1] + ' هزار';
          if(LArray[i+1].trim() == 'هزار'){
            LArray[i+2] = LArray[i+2] + ' هزار';
            LArray[i+1] = '';
          }
        }
      }
      else if(i==6 && (LArray[6] || LArray[7] || LArray[8])){
        LArray[i] = LArray[i] + ' میلیون';
        if(LArray[i].trim() == 'میلیون'){
          LArray[i] = '';
          LArray[i+1] = LArray[i+1] + ' میلیون';
          if(LArray[i+1].trim() == 'میلیون'){
            LArray[i+2] = LArray[i+2] + ' میلیون';
            LArray[i+1] = '';
          }
        }
      }
      else if(i==9 && (LArray[9] || LArray[10] || LArray[11])){
        LArray[i] = LArray[i] + ' میلیارد';
        if(LArray[i].trim() == 'میلیارد'){
          LArray[i] = '';
          LArray[i+1] = LArray[i+1] + ' میلیارد';
          if(LArray[i+1].trim() == 'میلیارد'){
            LArray[i+2] = LArray[i+2] + ' میلیارد';
            LArray[i+1] = '';
          }
        }
      }

      if(LArray[i] != '' && LArray[i] != '*'){
        arrayList.push(LArray[i]);
      }
    }
    for (let i = arrayList.length-1 ; i >= 0; i--){
      if(i > 0){
        retVal = retVal + arrayList[i] + ' و ';
      }
      if(i==0){
        retVal = retVal + arrayList[i];
      }
    }
    if(isToman && retVal.length > 0){
      retVal = retVal + ' تومان';
    }
    else if (!isToman){
      retVal = retVal + ' ریال';
    }
    return retVal;
  }
}

